// Routing
import { Link } from 'react-router-dom'

// Styling
import styled, { keyframes } from 'styled-components'

import { motion } from 'framer-motion'

// Importing Images
import wys1 from '../images/wys/architecture_diagram.png'
import wys2 from '../images/wys/ui_charts.png'
import wys3 from '../images/wys/ui_table.png'

// Importing components
import {
    ButtonWrapper,
    Hide,
    ProjectContainer,
} from '../components/ProjectInfoGraphinTunes'

// Animations, Scroll and Icons
import { pageAnimation, Fade, imageAnimation, FadeLine } from './Animation'
import { ScrollToTop } from './ScrollToTop'
import { IoCaretBackCircleOutline } from 'react-icons/io5'
import { IconContext } from 'react-icons'

const ProjectInfoWYS = () => {
    return (
        <ProjectContainer
            variants={pageAnimation}
            initial="hidden"
            animate="show"
        >
            <IconContext.Provider
                value={{
                    color: 'white',
                    size: '70px',
                    style: { marginLeft: '3rem' },
                }}
            >
                <Link to="/">
                    <Logo>
                        <motion.h2 variants={Fade}>Chirag Rao</motion.h2>
                        <motion.div variants={Fade}>
                            <IoCaretBackCircleOutline className="back" />
                        </motion.div>
                    </Logo>
                </Link>
            </IconContext.Provider>
            <div className="header">
                <motion.h1 variants={FadeLine} style={{ fontSize: '4rem' }}>
                    Watch Your Spend
                </motion.h1>
                <motion.h2
                    variants={Fade}
                    style={{
                        textAlign: 'center',
                        width: '40%',
                        marginTop: '3rem',
                    }}
                >
                    Second Place at{' '}
                    <a
                        style={{ textDecoration: 'none', color: 'white' }}
                        href="https://acdblr-blogathon.devpost.com"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        <GlitterText>AWS UG Blogathon 2025!!</GlitterText>
                    </a>{' '}
                </motion.h2>
                <motion.h3
                    variants={Fade}
                    style={{
                        textAlign: 'center',
                        width: '70%',
                        fontSize: '2.5rem',
                    }}
                >
                    Watch-Your-Spend is a purely bank-agnostic cloud-native,
                    serverless application, that uses AI conversational agents
                    to analyze your bank statements, by automating OCR text
                    detection and providing analytics, all in real-time.
                </motion.h3>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={wys2}
                        style={{ margin: '1rem 0rem' }}
                        alt="gtimage"
                    />
                </Hide>
                <Hide>
                    <motion.img
                        variants={imageAnimation}
                        src={wys3}
                        style={{
                            margin: '1rem 0rem',
                        }}
                        alt="gtimage"
                    />
                </Hide>
            </div>
            <div className="content">
                <div className="top">
                    <div className="text" style={{ marginBottom: '2.5rem' }}>
                        <motion.h1
                            variants={FadeLine}
                            style={{ textAlign: 'center' }}
                        >
                            Introduction
                        </motion.h1>
                        <motion.p
                            variants={Fade}
                            style={{ textAlign: 'center' }}
                        >
                            Watch-Your-Spend is a purely bank-agnostic
                            cloud-native, serverless application, that uses AI
                            conversational agents to analyze your bank
                            statements. The USP of this application is that it
                            analyzes your financial history, without you having
                            to enter details of each and every transaction
                            manually.
                            <br />
                            <br />
                            It automates workflows of using OCR to scan your
                            bank statement, feeding the parsed table transaction
                            data to an AI agent, which then processes the data,
                            and provides analytics on your spending habits,
                            based on a few global system prompts, and fallback
                            mechanisms to ensure consistency across all
                            generated text.
                            <br />
                            <br />
                            It also processes transactions real-time via web
                            sockets, and sends push notifications to the user,
                            when a pdf is done processing.
                            <br />
                            <br />
                            <b>
                                View the Blog! -{' '}
                                <a
                                    style={{ color: '#23d997' }}
                                    href="https://aws-blogathon-watch-your-spend.netlify.app/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    https://aws-blogathon-watch-your-spend.netlify.app/
                                </a>
                            </b>
                        </motion.p>
                    </div>
                    <Hide style={{ width: '100%' }}>
                        <div className="imageflex">
                            <LargeImage
                                variants={imageAnimation}
                                src={wys1}
                                alt="High Level Architecture Diagram"
                            />
                        </div>
                    </Hide>
                </div>
                <div className="imageflex">
                    <div className="textinner">
                        <motion.h3 variants={Fade}>
                            This web app's rich tech stack and serverless
                            infrastructure components.
                        </motion.h3>
                        <motion.p variants={Fade}>
                            <b style={{ color: '#23d997' }}>1.</b> Various AWS
                            Services - Highlighted above.
                            <br />
                            <b style={{ color: '#23d997' }}>2. </b> Next JS -
                            For the front-end app.
                            <br />
                            <b style={{ color: '#23d997' }}>3. </b> Recharts -
                            For the charts and graphs.
                            <br />
                            <b style={{ color: '#23d997' }}>4. </b> Vercel - For
                            hosting the front-end app.
                            <br />
                        </motion.p>
                    </div>
                </div>
                <div className="imageflex">
                    <div className="textinner">
                        <motion.h3 variants={Fade}>
                            More details to access repo and read documentation?
                        </motion.h3>
                        <motion.p variants={Fade}>
                            Check out my repository of this project on Github!
                            You can also check out my blog highlighted above for
                            greater detail.
                        </motion.p>
                    </div>
                </div>
                <ButtonWrapper>
                    <motion.button variants={Fade}>
                        <a
                            style={{ textDecoration: 'none', color: 'white' }}
                            href="https://watch-your-spend-4516543f4b4d5472.vercel.app/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Visit the Website!
                        </a>
                    </motion.button>
                    <motion.button variants={Fade}>
                        <a
                            style={{ textDecoration: 'none', color: 'white' }}
                            href="https://github.com/SpaceFace02/watch-your-spend-v1"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            View the Github Repo
                        </a>
                    </motion.button>
                </ButtonWrapper>
            </div>
            <ScrollToTop />
        </ProjectContainer>
    )
}

export const Logo = styled(motion.div)`
    position: absolute;
    top: 10px;
    left: 10px;
    font-family: 'Lobster';
    font-size: '1rem';
    float: right;
    display: flex;
    align-items: flex-end;
    padding: 0rem 1rem;
    margin: 2rem 0rem;
    .back {
        display: none;
    }
    @media screen and (max-width: 520px) {
        h2 {
            display: none;
        }
        .back {
            display: block;
        }
    }
`

const LargeImage = styled(motion.img)`
    display: block;
    margin: 1rem auto;
    width: 80%;
    max-width: 80%;
    height: auto;
    object-fit: contain;
    border-radius: 8px;

    @media (max-width: 900px) {
        width: 100%;
        max-width: 100%;
        transform: translateX(-50%);
    }

    @media (max-width: 600px) {
        width: 100%;
        max-width: 100%;
        margin: 1rem 0;
        border-radius: 8px;
        transform: translateX(-50%);
    }
`

const glitter = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`

const GlitterText = styled.span`
    background: linear-gradient(90deg, #23d997, #fff700, #23d997, #fff700);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${glitter} 2s linear infinite;
    font-weight: bold;

    &::after {
        content: '';
        display: block;
        height: 4px;
        margin-top: 4px;
        border-radius: 2px;
        background: linear-gradient(90deg, #23d997, #fff700, #23d997, #fff700);
        background-size: 200% 200%;
        animation: ${glitter} 2s linear infinite;
    }
`

export default ProjectInfoWYS
